export default __webpack_public_path__ + "static/media/xmasbox.67c05e43.svg";